export default __webpack_public_path__ + "static/flexibility-icon-1942873ceb4a5b62962a7510b77b5c84.png";